import React from 'react';

interface IconProps {
  size?: number;
}

interface SvgProps extends IconProps {
  children: React.ReactNode;
}

const Svg = ({ size = 16, children }: SvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
  >
    {children}
  </svg>
);

const UndoIconImpl = ({ size }: IconProps = {}) => (
  <Svg size={size}>
    <polyline points='1 4 1 10 7 10' />
    <path d='M3.51 15a9 9 0 1 0 2.13-9.36L1 10' />
  </Svg>
);

const RedoIconImpl = ({ size }: IconProps = {}) => (
  <Svg size={size}>
    <polyline points='23 4 23 10 17 10' />
    <path d='M20.49 15a9 9 0 1 1-2.13-9.36L23 10' />
  </Svg>
);

const CutIconImpl = ({ size }: IconProps = {}) => (
  <Svg size={size}>
    <circle cx='6' cy='6' r='3' />
    <circle cx='6' cy='18' r='3' />
    <line x1='20' y1='4' x2='8.12' y2='15.88' />
    <line x1='14.47' y1='14.48' x2='20' y2='20' />
    <line x1='8.12' y1='8.12' x2='12' y2='12' />
  </Svg>
);

const CopyIconImpl = ({ size }: IconProps = {}) => (
  <Svg size={size}>
    <rect x='9' y='9' width='13' height='13' rx='2' />
    <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' />
  </Svg>
);

const PasteIconImpl = ({ size }: IconProps = {}) => (
  <Svg size={size}>
    <path d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' />
    <rect x='8' y='2' width='8' height='4' rx='1' />
  </Svg>
);

const BackArrowIconImpl = ({ size }: IconProps = {}) => (
  <Svg size={size}>
    <line x1='19' y1='12' x2='5' y2='12' />
    <polyline points='12 19 5 12 12 5' />
  </Svg>
);

export const UndoIcon = React.memo(UndoIconImpl);
export const RedoIcon = React.memo(RedoIconImpl);
export const CutIcon = React.memo(CutIconImpl);
export const CopyIcon = React.memo(CopyIconImpl);
export const PasteIcon = React.memo(PasteIconImpl);
export const BackArrowIcon = React.memo(BackArrowIconImpl);
